import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Box,
  useTheme,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FAQPage = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const theme = useTheme();

  const handleAccordionChange = (index) => (_, isExpanded) => {
    setExpandedIndex(isExpanded ? index : null);
  };

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          width: "100%",
          mt: { xs: 8, md: 12 },
          mb: { xs: 6, md: 10 },
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          borderRadius: 4,
          overflow: "hidden",
          backgroundColor: theme.palette.background.paper,
          p: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Grid
          container
          spacing={{ xs: 3, md: 5 }}
          alignItems="center"
        >
          {/* Image - Mobile First */}
          <Grid
            item
            xs={12}
            md={5}
            order={{ xs: 1, md: 2 }}
            display="flex"
            justifyContent="center"
          >
            <Box
              component="img"
              src="https://ik.imagekit.io/arthgyan/Arthgyan_Web/faq"
              alt="FAQ"
              sx={{
                width: "100%",
                maxWidth: { xs: "280px", sm: "350px", md: "100%" },
                height: "auto",
                borderRadius: 3,
              }}
            />
          </Grid>

          {/* FAQ Section */}
          <Grid
            item
            xs={12}
            md={7}
            order={{ xs: 2, md: 1 }}
          >
            <Typography
              variant="h4"
              align="center"
              sx={{
                fontSize: { xs: "22px", sm: "26px", md: "32px" },
                fontWeight: 700,
                mb: 3,
                color: theme.palette.primary.main,
              }}
            >
              Frequently Asked Questions
            </Typography>

            {faqData.map((faq, index) => {
              const isExpanded = expandedIndex === index;

              return (
                <Accordion
                  key={index}
                  expanded={isExpanded}
                  onChange={handleAccordionChange(index)}
                  sx={{
                    mb: 1.5,
                    borderRadius: 2,
                    overflow: "hidden",
                    backgroundColor: theme.palette.secondary.main,
                    "&:before": { display: "none" },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{
                          color: theme.palette.primary.main,
                          transform: isExpanded
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "0.3s",
                        }}
                      />
                    }
                    sx={{
                      px: { xs: 2, md: 3 },
                      py: { xs: 1.2, md: 1.5 },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: "14px", sm: "15px", md: "16px" },
                        color: theme.palette.text.primary,
                      }}
                    >
                      {faq.question}
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                      px: { xs: 2, md: 3 },
                      py: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "13px", sm: "14px", md: "15px" },
                        lineHeight: 1.6,
                      }}
                    >
                      {faq.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

const faqData = [
  {
    question: "What is Arthgyan?",
    answer:
      "Arthgyan is a platform that provides financial insights and services.",
  },
  {
    question: "Why choose ArthGyan?",
    answer:
      "ArthGyan is one of India's fastest-growing digital platforms for personal finance products like banking, investment, and insurance.",
  },
  {
    question: "What services do you offer?",
    answer:
      "We offer banking, investment, and insurance services including credit cards, loans, mutual funds, FDs, and more.",
  },
  {
    question: "Are there charges involved?",
    answer:
      "ArthGyan is free for users. We charge a nominal fee to mutual fund companies.",
  },
  {
    question: "Still have questions?",
    answer:
      "Email us at support@arthgyan.com. Average response time is 48–72 hours.",
  },
];

export default FAQPage;
